var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var icon = {
    search: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/search%3C/title%3E%3Cpath fill='XXXXX' d='M84.652 78.995l39.336 39.336c.776.776.78 2.046-.003 2.823l-2.842 2.82a2.004 2.004 0 0 1-2.834-.008L78.995 84.652A47.809 47.809 0 0 1 48 96C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48a47.809 47.809 0 0 1-11.348 30.995zM48 88c22.091 0 40-17.909 40-40S70.091 8 48 8 8 25.909 8 48s17.909 40 40 40z'  fill-rule='evenodd'/%3E%3C/svg%3E",
    delete: "data:image/svg+xml;charset=utf-8,%3Csvg baseProfile='tiny' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23666' d='M16 .703L15.298 0 8 7.298.702 0 0 .703 7.298 8 0 15.297.702 16 8 8.702 15.298 16l.702-.703L8.702 8z'/%3E%3C/svg%3E",
};
var getIcon = function (icon, size, fill) {
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: 'icon',
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var inputSearch = {
    label: 'input-search',
    display: 'flex',
    alignItems: 'center',
    padding: "".concat(8 - 2, "px ").concat(8, "px ").concat(8 - 2, "px ").concat(8, "px"),
};
export var iconWrapperLarge = {
    label: 'iwrapper-large',
    marginRight: 8,
    marginTop: 0,
};
export var searchWrapper = {
    background: '#f5f5f5',
    borderBottom: '1px solid #cccccc',
    borderTop: '1px solid #cccccc',
    padding: 16,
};
export var searchWrapperTopBorderOnly = __assign(__assign({}, searchWrapper), { borderBottom: 0 });
export var searchWrapperBottomBorderOnly = __assign(__assign({}, searchWrapper), { borderTop: 0 });
// Standard
export var inputActions = {
    label: 'actions',
    marginTop: 0,
};
// Large
export var searchIconLarge = __assign(__assign({}, getIcon(icon.search, 20, '#1588af')), { marginTop: 2 });
export var searchIconDisabledLarge = __assign(__assign({}, getIcon(icon.search, 20, '#a6a6a6')), { marginTop: 2 });
export var clearIconLarge = __assign(__assign({}, getIcon(icon.delete, 20, '#1588af')), { marginTop: 0 });
export var clearIconDisabledLarge = __assign(__assign({}, getIcon(icon.delete, 20, '#a6a6a6')), { marginTop: 0 });
export var inputActionsLarge = {
    label: 'actions-large',
    marginTop: 4 * -1,
    marginRight: 0,
};
export var inputLarge = {
    label: 'input-large',
    fontSize: 18,
    height: 48,
    padding: "".concat(12 - 1, "px ").concat(8, "px"),
};
export var inputLargeDisabled = {
    backgroundColor: '#eaeaea',
};
export var valueLarge = {
    label: 'value-large',
    lineHeight: "".concat(24, "px"),
};
